






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { RequestStatus } from '../utils/constans';
import { formatBackTime } from '../utils/common';
import { iActivies, iBook } from '../typings/publication';
import $api from '../api';
import mockBook from '../mock/book';

@Component
export default class CompActivites extends Vue {
  private activityList: string[] = [];
  private enActivityList: string[] = [];
  private bookList: iBook[] = [];
  private enBookList: iBook[] = [];
  private slideWindoStyle: string = '';
  private enSlideWinowStyle: string = '';

  mounted() {
    // this.getActivityList();
    this.initActivityList();
    this.getBooksList();
  }

  initActivityList(){
    const activityList = [
      '四核物联网网关',
      '无线传感器网络ROSE算法',
      '物联网多种群协同进化ROCKS模型',
      '物联网数据收集EABS协议',
      '物联网通信节点',
      '智慧城市5G方案',
      '智慧物联网实验平台',
      '智能车联网动态传输策略',
    ];
    const enActivityList = [
      'Quad-core IoT Gateway',
      'Wireless sensor network ROSE algorithm',
      'IoT multi-group co-evolution ROCKS model',
      'IoT Data Collection EABS Protocol',
      'IoT Comm Node',
      'Smart City 5G Solution',
      'Smart IoT Experiment Platform',
      'Intelligent vehicle networking dynamic transmission strategy',
    ];

    this.activityList = activityList.concat(activityList);
    this.enActivityList = enActivityList.concat(enActivityList);
  }

  getBooksList() {
    const succ = (res: any) => {
      (res as any).map((record: iBook) => {
        if (record.language === '英语' && this.enBookList.length < 5) {
          this.enBookList.push(record);
        } else if (record.language !== '英语' && this.bookList.length < 5) {
          this.bookList.push(record);
        }
      });
    }
    if (this.$store.state.offModel) {
      succ(mockBook);
    } else {
      $api.publication.findAllBookClient().then(succ)
    }
  }
}
